import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Line,
  ComposedChart,
} from "recharts";
import { formatCurrency } from "../../../../utils/formatters";

const BaseViewChart = ({
  assetBalances,
  taxTotals,
  currentYear,
  yearsToProject,
}) => {
  // Prepare data for the chart
  const chartData = assetBalances.map((balance, index) => {
    const year = currentYear + index;
    const taxData = taxTotals[index];

    return {
      year,
      nonQualified: balance.nonQualified,
      taxDeferred: balance.taxDeferred,
      roth: balance.roth,
      totalAssets: balance.nonQualified + balance.taxDeferred + balance.roth,
      taxesPaid: taxData.taxOwed,
      cumulativeTaxes: taxTotals
        .slice(0, index + 1)
        .reduce((sum, tax) => sum + tax.taxOwed, 0),
    };
  });

  return (
    <div className="w-full h-[600px] mt-8">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" label={{ value: "Year", position: "bottom" }} />
          <YAxis
            yAxisId="left"
            label={{
              value: "Asset Balance ($)",
              angle: -90,
              position: "insideLeft",
            }}
            tickFormatter={(value) => formatCurrency(value, false)}
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            label={{
              value: "Taxes ($)",
              angle: 90,
              position: "insideRight",
            }}
            tickFormatter={(value) => formatCurrency(value, false)}
          />
          <Tooltip
            formatter={(value) => formatCurrency(value)}
            labelFormatter={(year) => `Year: ${year}`}
          />
          <Legend />

          {/* Stacked bars for asset balances */}
          <Bar
            yAxisId="left"
            dataKey="nonQualified"
            stackId="assets"
            fill="#4299E1"
            name="Non-Qualified"
          />
          <Bar
            yAxisId="left"
            dataKey="taxDeferred"
            stackId="assets"
            fill="#48BB78"
            name="Tax-Deferred"
          />
          <Bar
            yAxisId="left"
            dataKey="roth"
            stackId="assets"
            fill="#9F7AEA"
            name="Roth"
          />

          {/* Lines for tax data */}
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="taxesPaid"
            stroke="#F56565"
            name="Annual Taxes"
            strokeWidth={2}
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="cumulativeTaxes"
            stroke="#ED8936"
            name="Cumulative Taxes"
            strokeWidth={2}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BaseViewChart;
